/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */

import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import ErrorBoundary from './containers/ErrorBoundary';
import ReactDom from 'react-dom';

import Root from './containers/Root.js';

import configureStore from './store';

const store = configureStore();

let rootDiv = document.getElementById('root');

// Generic render function so it can be reused
// for hot reloading
export const render = () => {
  ReactDom.render(
      <Provider store={store}>
        <BrowserRouter basename="/">
          <ErrorBoundary>
            <Root />
          </ErrorBoundary>
        </BrowserRouter>
      </Provider>,
    rootDiv
  );
};

/*
  If Webpack Hot Module Reload is enabled, rerender when module is reloaded
  Enabled in dev mode so changes in files can be rebundled and reloaded without
  manually refreshing the page, speeds up development feedback loop
*/
if (module.hot) {
  module.hot.accept('./containers/Root.js', () => {
    const NextRoot = require('./containers/Root.js').default;
    render(NextRoot);
  });
}
